import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import config, { getHeaders } from "../config";
import { useLanguage } from "../Context/LangContext";
import { loginText as txt } from "../Text";
import funZoneBanner from "../assets/images/funzone_banner.png";
import "./Login.scss";
import Modal from "./Modal";
import { SendGuiDataEvents } from "../CommonScript";
import { reactLocalStorage } from "reactjs-localstorage";
import Loader from "../commonComponents/Loader";
import { Base64 } from "js-base64";

const Login = ({ loginPage_txt }) => {
    const { language } = useLanguage();
    const [loading, setLoading] = useState(false);
    const [msisdn, setMsisdn] = useState("");
    const history = useHistory();
    console.log("::::::::::MSISDN PAGE TEXT::::::::::::::", loginPage_txt)

    useEffect(() => {
        let guiDataEvents = {};
        guiDataEvents["w_action"] = "login";
        guiDataEvents["page"] = "login";
        guiDataEvents["event"] = "open";
        SendGuiDataEvents(guiDataEvents);
    }, []);
    const handleInputChange = (e) => {
        const value = e.target.value;
        // Allow only alphanumeric characters
        if (/^[0-9]*$/.test(value) || value === "") {
            setMsisdn(value);
            reactLocalStorage.set("msisdn", value)
        }
    };
    const checkSub = () => {
        if (isMsisdn) {
            reactLocalStorage.set("msisdn", msisdn)
            setLoading(true)
            const url = `${config.get('base')}${config.get('checkSub')}`;
            const headers = {
                ...getHeaders(),
                Language: language
            }
            fetch(url, {
                method: 'POST',
                body: JSON.stringify({ 'msisdn': msisdn }),
                headers: headers
            })
                .then(res => {
                    if (!res.ok) { throw res }
                    return res.json()
                })
                .then((result) => {
                    console.log('result message::', result);
                    setLoading(false);
                    reactLocalStorage.set("subStatus", result?.subStatus?.toUpperCase())
                    if (result?.status === 'success') {
                        setLoading(false)
                        if (result?.subStatus === "active") {
                            console.log("user is active")
                            reactLocalStorage.set("status", result?.subStatus)
                            reactLocalStorage.set("msisdn", result?.msisdn)
                            reactLocalStorage.set("status_display", result?.status_display)
                            reactLocalStorage.set('lastCheckSubTime', new Date().getTime());
                            reactLocalStorage.set("uid", result?.uid);
                            history.push("/home")
                        }
                        else if (result?.subStatus === "new") {
                            reactLocalStorage.set('initStatus', 'new');
                            // history.push('/subscription')
                            let encodedMessages = "S2FtaSB0aWRhayBkYXBhdCBtZW1wZXJvbGVoIHN0YXR1cyBiZXJsYW5nZ2FuYW4gQW5kYSwgU2lsYWthbiBiZXJsYW5nZ2FuYW4gYXRhdSBjb2JhIGJlYmVyYXBhIHNhYXQgbGFnaS4="
                            history.push(`/thanks?msg=${encodedMessages}`)
                        }
                        else {
                            const messages = [
                                result?.message,
                                result?.message1,
                                result?.message2,
                                result?.message3
                            ];
                            const encodedMessages = messages.map(msg => Base64.encode(msg)).join(',');
                            history.push(`/thanks?msgs=${encodedMessages}`)
                        }
                        reactLocalStorage.set("planType", result?.subType);
                        reactLocalStorage.set("validity", result?.validity);
                    }
                    else {
                        setLoading(false)
                        reactLocalStorage.set("checkStatus", result?.status?.toUpperCase())
                        history.push(`/thanks?msg=${Base64.encode(result?.message)}`)
                    }
                },
                    (error) => {
                        console.log('error:::', error)
                        history.push("/thanks");
                        setLoading(false);
                    })
        }
    }
    const isMsisdn = msisdn.length >= 8;
    if (loading) return <Loader />;

    return (
        <>
            {/* {homeLogo && <img src={homeLogo} alt="logo"  className="" height="100px" width="100px"/>} */}
            <div className="">
                <img src={funZoneBanner} alt="enter msisdn" className="login-banner-image" />
                <h1 className="my-4 font-bold text-lg text-start px-5">{loginPage_txt?.title}</h1>
               <div className="px-5">
               <div className='input-container'>
                    <input
                    placeholder={loginPage_txt?.ph}
                        className="msisdn-field py-3"
                        type="text"
                        name="otp"
                        maxLength="13"
                        value={msisdn}
                        onChange={handleInputChange}
                    />
                </div>
                <button className="login-btn btn w-full text-white font-bold my-5" disabled={!isMsisdn} onClick={checkSub}>
                    {loginPage_txt?.btn_txt}
                </button>
               </div>
            </div>
        </>
    )
}

export default Login